/**
 * Persistent house-ad slot in the cabinet gallery footer (sc-6959).
 *
 * Unlike the in-game slot (ad-slot.ts) this one has no reveal delay — the
 * gallery is chrome, not gameplay, so the banner is present whenever the
 * cabinet is in select mode. Rotates every 15s. Shares the bundled 728x90
 * house creatives. While a game plays the #play-layer overlay covers the
 * footer, so the rotation skips (no impression logged for a hidden bar).
 */

import { recordAdEvent } from '../api/client.js';
import { getOrCreateDeviceId } from '../runtime/identity.js';
import { pickAd } from './ad-slot.js';

const ROTATE_MS = 15_000;

let current = '';

export function mountCabinetAd(): void {
  const host = document.getElementById('cabinet-ad');
  if (!(host instanceof HTMLElement) || host.dataset.mounted === '1') return;
  host.dataset.mounted = '1';

  const link = document.createElement('a');
  link.className = 'control-panel__ad-link';
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute('aria-label', 'Sponsor message');
  const img = document.createElement('img');
  img.width = 728;
  img.height = 90;
  img.decoding = 'async';
  img.loading = 'lazy';
  link.appendChild(img);
  host.appendChild(link);

  link.addEventListener('click', () => {
    if (current) recordAdEvent({ slot: 'cabinet-footer', adId: current, event: 'click', deviceId: getOrCreateDeviceId() });
  });

  const show = (): void => {
    const ad = pickAd(current || undefined);
    current = ad.id;
    img.src = ad.img;
    img.alt = ad.alt;
    link.href = ad.href;
    link.dataset.adId = ad.id;
    link.classList.remove('is-fading');
    void link.offsetWidth;
    link.classList.add('is-visible');
    recordAdEvent({ slot: 'cabinet-footer', adId: ad.id, event: 'impression', deviceId: getOrCreateDeviceId() });
  };

  show();
  window.setInterval(() => {
    // Skip the swap while a game is playing — the #play-layer overlay
    // covers the footer, so there's no one to show it to.
    const playLayer = document.getElementById('play-layer');
    if (playLayer && !playLayer.hidden) return;
    link.classList.add('is-fading');
    window.setTimeout(show, 220);
  }, ROTATE_MS);
}
